import * as angular from "angular";

angular
  .module('bringoz.admin.vehicles')
  .config(vehiclesConfig);

/* @ngInject */
function vehiclesConfig($stateProvider) {

  $stateProvider

    // Depots
    .state('vehicles', {
      parent: 'bringoz.site',
      url: '/vehicles',
      template: '<vehicles-view></vehicles-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Vehicles"});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    });

}
